import React from 'react';
import { classNames } from '@panwds/react-ui';
import { useTableLayoutEnabled } from '../TableLayout/TableLayout.esm.js';
import '@panwds/icons';
import '../TableContext/TableContext.esm.js';
import '../TableContext/TableProvider.esm.js';
import 'uuid';
import 'react-intl';

function FooterCell({ appearance = "primary", column, }) {
    const tableLayoutEnabled = useTableLayoutEnabled();
    const classes = classNames("tw-font-lato tw-box-border tw-border-solid tw-border-gray-300 tw-border-0 tw-px-4 tw-py-1 tw-items-center tw-flex tw-h-full tw-w-full tw-leading-tight tw-border-r dark:tw-border-gray-950", appearance === "primary" && "border-r", (tableLayoutEnabled || appearance === "secondary") && "tw-border-t");
    return (React.createElement("div", { "data-table-column-id": column.id, ...column.getFooterProps({ role: "cell" }) },
        React.createElement("div", { className: classes }, column.render("Footer"))));
}

export { FooterCell };
//# sourceMappingURL=FooterCell.esm.js.map
